
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Control } from "react-hook-form";
import { CharacterFormData } from "../validation/characterSchema";
import { ImageUpload } from "../components/ImageUpload";

interface VisualAssetsSectionProps {
  control: Control<CharacterFormData>;
}

export const VisualAssetsSection = ({ control }: VisualAssetsSectionProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Visual Assets</h3>
      
      <FormField
        control={control}
        name="image_url"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <ImageUpload
                label="Main Image"
                currentPath={field.value}
                onPathChange={field.onChange}
                placeholder="Upload image or enter storage path"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="avatar_url"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <ImageUpload
                label="Avatar Image"
                currentPath={field.value}
                onPathChange={field.onChange}
                placeholder="Upload image or enter storage path"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
